import extractCode from 'toxilibs/extract_code.js'
import urlParams from 'toxilibs/url_params.js'
import colors from '../colors.js'

let {codeLang, progression} = urlParams()


if (progression === 'python' && !codeLang) {
    codeLang = 'python'
}


function format (code) {
    code = extractCode.fromFunction(code)
    if (codeLang === 'python') {
        code = convertToPythonLanguage(code)
    } else if (codeLang !== 'javascript') {
        code = convertToMetaLanguage(code)
    }

    return code
}



function convertToMetaLanguage (code) {
    code = code.replace(/for\s*\(let \w{1}\s*=\s*0;\s*\w{1}\s*<\s*(\w+);\s*\w{1}\+\+\)/g, 'repeat ($1)')
    code = code.replace(/var /g, '')
    code = code.replace(/ = function/g, ' function')

    return code
}


function convertToPythonLanguage (code) {
    code = code.replace(/for\s*\(let \w{1}\s*=\s*0;\s*\w{1}\s*<\s*(\w+);\s*\w{1}\+\+\)/g, 'for i in range($1)')
    code = code.replace(/function (\w+) \(\) /g, 'def $1 () ')
    code = code.replace(/\(!(.*)\)/g, 'not ($1)')
    code = code.replace(/{/g, ':')
    code = code.replace(/\s*}(?! \w+)/g, '')
    code = code.replace(/} /g, '')
    code = code.replace(/else if/g, 'elif')

    return code
}


function convertColorConditionsForSizeSetter (code) {
    for (let colorName in colors) {
        code = code.replace(new RegExp('\\(' + colorName + '\\(\\)\\)', 'gm'), '<i class="custom_icon icon-circle">&#xf111;</i>')
    }

    return code
}


function convertColorConditionsForHighlighter (code) {
    for (let colorName in colors) {
        code = code.replace(new RegExp('\\(' + colorName + '\\(\\)\\)', 'gm'), colorName)
    }

    return code
}





export default {
    format,
    convertColorConditionsForSizeSetter,
    convertColorConditionsForHighlighter
}

